import * as React from 'react';

import {CreateCustomField} from 'shells/create-custom-field/create-custom-field';
import type {CreateCustomFieldResponse} from 'shells/create-custom-field/types';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Sidebar} from 'shells/sidebar/sidebar';

import type {EntityCustomFieldType} from 'nutshell-graphql-types';

import {CreateCustomFieldMutationWrapper} from '../../core/custom-field/graphql/graphql-wrappers/create-custom-field-mutation-wrapper';

type Props = {
    onCreateSuccess: (response: CreateCustomFieldResponse) => any;
    onClose: () => any;
    customFieldName: string;
    customFieldType?: EntityCustomFieldType;
};

export function CreateCustomFieldSidebar(props: Props) {
    // Ref to 'Add' button in sidebar header
    const sidebarAddButtonRef = React.useRef(undefined);

    return (
        <CreateCustomFieldMutationWrapper>
            {({onCreate, loading, error, reset}) => (
                <Sidebar
                    isOpen={true}
                    obscurePage={false}
                    preventBodyScroll={false}
                    canClickOutsideToClose={false}
                    onClose={props.onClose}
                    saveText='Add'
                    getButtonRef={sidebarAddButtonRef}
                    onSave={() => {}} // Goofy but needed to render 'Add' button
                    isSaving={loading}
                    headerTitle='Add New Text Custom Field'
                >
                    <div className='pad-16'>
                        {error ? (
                            <div className='mb-16'>
                                <FlashBanner
                                    type='error'
                                    hasBorder={true}
                                    leftAlignContent={true}
                                    onHidden={reset}
                                >
                                    {error}
                                </FlashBanner>
                            </div>
                        ) : undefined}
                        <CreateCustomField
                            customFieldType={props.customFieldType}
                            name={props.customFieldName}
                            onCreate={(createCustomFieldVariables) =>
                                onCreate({
                                    customField: {...createCustomFieldVariables},
                                })
                            }
                            createButtonRef={sidebarAddButtonRef}
                            onCreateSuccess={(response: CreateCustomFieldResponse) => {
                                props.onCreateSuccess(response);
                            }}
                        />
                    </div>
                </Sidebar>
            )}
        </CreateCustomFieldMutationWrapper>
    );
}
